var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTweeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_64_345)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0343 22.3181L33.9907 13.0625H32.1073L25.1984 21.0994L19.6793 13.0625H13.3142L21.6634 25.2085L13.3142 34.9072H15.1976L22.4993 26.4272L28.3306 34.9072H34.6957L26.0343 22.3181ZM23.456 25.3193L22.6101 24.1108L15.8824 14.4826H18.7829L24.2114 22.2476L25.0574 23.4561L32.1174 33.5577H29.2169L23.456 25.3193Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_345",
    x1: 7.03181,
    y1: 7.02939,
    x2: 40.975,
    y2: 40.9726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23004A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9565,
    stopColor: "#020003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweeter);
export default __webpack_public_path__ + "static/media/tweeter.db5b6d0f11d0b2eacb2b2ed2f30f3c36.svg";
export { ForwardRef as ReactComponent };